import React, { createContext, useState } from "react";
import {Language, TranslateScope} from '../interfaces/languages';

export interface ILanguageContext {
    store: Store,
    setStore: (store: Store) => void
}

export interface Store {
    languageAvailable:Language[],
    languageSelected:Language[],
    languageOption:number,
    translateScope:TranslateScope | null
}

const storeDefaults:ILanguageContext = {
    store: {
        languageAvailable: [],
        languageSelected:[],
        languageOption:0,
        translateScope:null
    },
    setStore: () => {}
}

export const LanguageContext = createContext(storeDefaults);

export default ({ children }:{children:React.ReactNode}) => {

    const [store, setStore] = useState<Store>(storeDefaults.store);

    const context:ILanguageContext = {
        store: store,
        setStore: setStore
    }

    return (
        <LanguageContext.Provider value={context}>
            {children}
        </LanguageContext.Provider>
    )
}